import {
  useLazyGetContractPdfQuery,
  useLazyGetContractPdfByReservationQuery,
} from '../Service/extendedContractsApi';

/**
 * Helper function to download contract PDF using RTK Query
 * @param triggerGetPdf - RTK Query lazy trigger function
 * @param contractId - ID kontraktu
 * @param contractName - Nazwa pliku (opcjonalne)
 */
export const downloadContractPdf = async (
  triggerGetPdf: ReturnType<typeof useLazyGetContractPdfQuery>[0],
  contractId: number,
  contractName?: string
): Promise<void> => {
  try {
    const result = await triggerGetPdf(contractId).unwrap();

    if (!result) {
      throw new Error('Failed to download PDF - no data received');
    }

    const url = window.URL.createObjectURL(result);

    // Tworzymy link do pobrania
    const link = document.createElement('a');
    link.href = url;
    link.download = contractName || `Umowa_${contractId}.pdf`;

    // Dodajemy do DOM, klikamy i usuwamy
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Czyścimy URL
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading PDF:', error);
    throw error;
  }
};

/**
 * Helper function to open contract PDF in new tab using RTK Query
 * @param triggerGetPdf - RTK Query lazy trigger function
 * @param contractId - ID kontraktu
 */
export const openContractPdfInNewTab = async (
  triggerGetPdf: ReturnType<typeof useLazyGetContractPdfQuery>[0],
  contractId: number
): Promise<void> => {
  try {
    const result = await triggerGetPdf(contractId).unwrap();

    if (!result) {
      throw new Error('Failed to open PDF - no data received');
    }

    const url = window.URL.createObjectURL(result);

    // Otwieramy w nowej karcie
    window.open(url, '_blank');

    // URL zostanie automatycznie zwolniony gdy karta zostanie zamknięta
  } catch (error) {
    console.error('Error opening PDF:', error);
    throw error;
  }
};

/**
 * Helper function to download contract PDF by reservation ID using RTK Query
 * @param triggerGetPdfByReservation - RTK Query lazy trigger function
 * @param reservationId - ID rezerwacji
 * @param contractName - Nazwa pliku (opcjonalne)
 */
export const downloadContractPdfByReservation = async (
  triggerGetPdfByReservation: ReturnType<typeof useLazyGetContractPdfByReservationQuery>[0],
  reservationId: number,
  contractName?: string
): Promise<void> => {
  try {
    const result = await triggerGetPdfByReservation(reservationId).unwrap();

    if (!result) {
      throw new Error('Failed to download PDF - no data received');
    }

    const url = window.URL.createObjectURL(result);

    // Tworzymy link do pobrania
    const link = document.createElement('a');
    link.href = url;
    link.download = contractName || `Umowa_Rezerwacja_${reservationId}.pdf`;

    // Dodajemy do DOM, klikamy i usuwamy
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Czyścimy URL
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading PDF by reservation:', error);
    throw error;
  }
};

/**
 * Helper function to open contract PDF in new tab by reservation ID using RTK Query
 * @param triggerGetPdfByReservation - RTK Query lazy trigger function
 * @param reservationId - ID rezerwacji
 */
export const openContractPdfInNewTabByReservation = async (
  triggerGetPdfByReservation: ReturnType<typeof useLazyGetContractPdfByReservationQuery>[0],
  reservationId: number
): Promise<void> => {
  try {
    const result = await triggerGetPdfByReservation(reservationId).unwrap();

    if (!result) {
      throw new Error('Failed to open PDF - no data received');
    }

    const url = window.URL.createObjectURL(result);

    // Otwieramy w nowej karcie
    window.open(url, '_blank');

    // URL zostanie automatycznie zwolniony gdy karta zostanie zamknięta
  } catch (error) {
    console.error('Error opening PDF by reservation:', error);
    throw error;
  }
};
